import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';

import ShareIcons from 'components/editor/hubNavigation/shareIcons/shareIcons';

import s from 'components/editor/hubFooter/hubFooter.sss';

const copyrightDate = (typeof window !== 'undefined' ? new Date(window.__BUILD_DATE__) : new Date()).getFullYear();

export default class HubFooter extends Component {
	constructor(props) {
		super(props);
		this.renderLink = this.renderLink.bind(this);
	}

	getFooterData() {
		const navigationData = Store.get().data?.navigation?.content;
		return {
			links: navigationData?.footer?.links || [],
			legal: navigationData?.footer?.legal || [],
			copyright: navigationData?.footer?.copyright || `© ${copyrightDate} Universal Pictures`,
		};
	}

	renderLink(link) {
		if (typeof link === 'string') {
			const pages = Store.get().appData?.pages || {};
			link = { name: pages[link]?.name || link, destination: link };
		}
		if (!link?.name) return;
		if (!link.destination) {
			return <span>{link.name}</span>;
		}
		// Display all links as text (non-clickable) in CMS visual editor
		return <span>{link.name}</span>;
	}

	render() {
		const { links, legal, copyright } = this.getFooterData();

		return (
			<footer class={s.wrapper}>
				<div class={s.content}>
					<div class={s.main}>
						<div class={s.logo}>
							<img src={`${__IMAGE_ROOT__}/logo.svg`} width="79" height="40" alt="Universal Logo" />
						</div>
						<div class={s.linksWrapper}>
							{links.map((section, i) => (
								<div class={joinClasses(s.section, s.links)} key={i}>
									{Array.isArray(section) && section.map(this.renderLink)}
								</div>
							))}
						</div>
						<div class={s.shareWrapper}>
							<ShareIcons class={s.share} />
						</div>
					</div>
					<div class={s.legal}>
						{legal.map((link, i) => (
							<span key={i}>{this.renderLink(link)}</span>
						))}
					</div>
					<div class={s.copyright}>{copyright}</div>
				</div>
			</footer>
		);
	}
}
